module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-details"
  }, [(_vm.getSingleShipments.pod_timeofarrival_warning) ? _c('div', {
    staticClass: "alerts"
  }, _vm._l((_vm.parsedIncidents), function(incident, index) {
    return _c('div', {
      key: index,
      staticClass: "alert"
    }, [_vm._v("\n      " + _vm._s(incident.message) + "\n    ")])
  })) : _vm._e(), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    },
    on: {
      "click": function($event) {
        _vm.getShipmentLog(_vm.getSingleShipments)
      }
    }
  }, [_vm._v("\n      Shipment ID :\n      "), _c('strong', {
    staticStyle: {
      "color": "blue"
    }
  }, [_c('u', [_vm._v(_vm._s(_vm.getSingleShipments.id))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Booking No : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.booking_number))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_vm._v("Container : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.container_number))])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Container Type : " + _vm._s(_vm.getSingleShipments.container_type_str))])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Container ISO : " + _vm._s(_vm.getSingleShipments.container_type_iso))])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_vm._v("\n      Subscription ID :\n      "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.shipmentsubscription_id))])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Carrier Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.carrier_name))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Carrier SCAC : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.carrier_scac))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Carrier Release State :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.carrier_release_state))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Carrier Release Date :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.carrier_release_date ? (_vm.getSingleShipments.carrier_release_date | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Status Verbose : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.status_verbose))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Subscription Status :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.shipmentsubscription_status_verbose))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Subscription Lifecycle Status :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.lifecycle_status_verbose))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Bl No : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.bl_number))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("ID Date : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.id_date ? (_vm.getSingleShipments.id_date | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Empty Pickup Planned Initial :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.empty_pickup_planned_initial ? (_vm.getSingleShipments.empty_pickup_planned_initial | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Empty Pickup Planned Last :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.empty_pickup_planned_last ? (_vm.getSingleShipments.empty_pickup_planned_last | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Empty Pickup Actual :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.empty_pickup_actual ? (_vm.getSingleShipments.empty_pickup_actual | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Origin Pickup Planned Initial :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.origin_pickup_planned_initial ? (_vm.getSingleShipments.origin_pickup_planned_initial | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Origin Pickup Planned Last :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.origin_pickup_planned_last ? (_vm.getSingleShipments.origin_pickup_planned_last | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Origin Pickup Actual :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.origin_pickup_actual ? (_vm.getSingleShipments.origin_pickup_actual | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("POL Arrival Planned Initial :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pol_arrival_planned_initial ? (_vm.getSingleShipments.pol_arrival_planned_initial | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("POL Arrival Planned Last :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pol_arrival_planned_last ? (_vm.getSingleShipments.pol_arrival_planned_last | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("POL Arrival Actual :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pol_arrival_actual ? (_vm.getSingleShipments.pol_arrival_actual | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("POL Loaded Planned Initial :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pol_loaded_planned_initial ? (_vm.getSingleShipments.pol_loaded_planned_initial | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("POL Loaded Planned Last :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pol_loaded_planned_last ? (_vm.getSingleShipments.pol_loaded_planned_last | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("POL Loaded Actual :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pol_loaded_actual ? (_vm.getSingleShipments.pol_loaded_actual | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("POL VSL Departure Planned Initial :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pol_vsldeparture_planned_initial ? (_vm.getSingleShipments.pol_vsldeparture_planned_initial | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("POL VSL Departure Planned Last :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pol_vsldeparture_planned_last ? (_vm.getSingleShipments.pol_vsldeparture_planned_last | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("POL VSL Departure Actual :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pol_vsldeparture_actual ? (_vm.getSingleShipments.pol_vsldeparture_actual | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("POL VSL Departure Detected :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pol_vsldeparture_detected ? (_vm.getSingleShipments.pol_vsldeparture_detected | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Leg 1 Voyage :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg1_voyage))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Leg 2 Voyage :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg2_voyage))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Leg 3 Voyage :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg3_voyage))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Leg 4 Voyage :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg4_voyage))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Leg 5 Voyage :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg5_voyage))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Created : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.created ? (_vm.getSingleShipments.created | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Modified : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.modified ? (_vm.getSingleShipments.modified | _vm.moment) : ""))])])])], 1), _vm._v(" "), (_vm.getSingleShipments.current_vessel_nextport) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Current Vessel Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Next Port Name :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.current_vessel_nextport.name))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Next Port Locode :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.current_vessel_nextport.locode))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Next Port ETA :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.current_vessel_nextport.eta ? (_vm.getSingleShipments.current_vessel_nextport.eta | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Position Lat :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.current_vessel_position.latitude))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Position Long :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.current_vessel_position.longitude))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Position Time :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.current_vessel_position.timestamp ? (_vm.getSingleShipments.current_vessel_position.timestamp | _vm.moment) : ""))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Position Heading :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.current_vessel_position.heading))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.current_vessel.name))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Imo : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.current_vessel.imo))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("ID : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.current_vessel.id))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp1_loc) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 1 Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp1_loc.name))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Locode : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp1_loc.locode))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Timezone : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp1_loc.timezone))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("City : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp1_loc.city))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("State : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp1_loc.state))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Country : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp1_loc.country))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp2_loc) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 2 Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp2_loc.name))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Locode : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp2_loc.locode))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Timezone : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp2_loc.timezone))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("City : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp2_loc.city))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("State : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp2_loc.state))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Country : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp2_loc.country))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp3_loc) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 3 Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp3_loc.name))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Locode : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp3_loc.locode))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Timezone : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp3_loc.timezone))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("City : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp3_loc.city))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("State : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp3_loc.state))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Country : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp3_loc.country))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp4_loc) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 4 Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp4_loc.name))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Locode : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp4_loc.locode))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Timezone : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp4_loc.timezone))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("City : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp4_loc.city))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("State : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp4_loc.state))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Country : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp4_loc.country))])])])], 1) : _vm._e(), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 1 VSL Arrival Details")])])]), _vm._v(" "), (_vm.getSingleShipments.tsp1_vslarrival_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.tsp1_vslarrival_planned_initial ? (_vm.getSingleShipments.tsp1_vslarrival_planned_initial | _vm.moment) : ""))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp1_vslarrival_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp1_vslarrival_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp1_vslarrival_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp1_vslarrival_actual)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp1_vslarrival_detected) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Detected :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp1_vslarrival_detected)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 1 Discharge Details")])])]), _vm._v(" "), (_vm.getSingleShipments.tsp1_discharge_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp1_discharge_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp1_discharge_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp1_discharge_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp1_discharge_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp1_discharge_actual)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 1 Loaded Details")])])]), _vm._v(" "), (_vm.getSingleShipments.tsp1_loaded_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp1_loaded_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp1_loaded_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp1_loaded_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp1_loaded_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp1_loaded_actual)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 1 VSL Departure Details")])])]), _vm._v(" "), (_vm.getSingleShipments.tsp1_vsldeparture_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp1_vsldeparture_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp1_vsldeparture_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp1_vsldeparture_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp1_vsldeparture_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp1_vsldeparture_actual)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp1_vsldeparture_detected) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Detected :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp1_vsldeparture_detected)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 2 VSL Arrival Details")])])]), _vm._v(" "), (_vm.getSingleShipments.tsp2_vslarrival_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_vslarrival_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp2_vslarrival_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3",
      "|": "",
      "moment": ""
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_vslarrival_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp2_vslarrival_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_vslarrival_actual)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp2_vslarrival_detected) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Detected :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_vslarrival_detected)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 2 Discharge Details")])])]), _vm._v(" "), (_vm.getSingleShipments.tsp2_discharge_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_discharge_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp2_discharge_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_discharge_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp2_discharge_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_discharge_actual)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 2 Loaded Details")])])]), _vm._v(" "), (_vm.getSingleShipments.tsp2_loaded_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_loaded_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp2_loaded_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_loaded_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp2_loaded_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_loaded_actual)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 2 VSL Departure Details")])])]), _vm._v(" "), (_vm.getSingleShipments.tsp2_vsldeparture_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_vsldeparture_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp2_vsldeparture_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_vsldeparture_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp2_vsldeparture_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_vsldeparture_actual)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp2_vsldeparture_detected) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Detected :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_vsldeparture_detected)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 3 VSL Arrival Details")])])]), _vm._v(" "), (_vm.getSingleShipments.tsp3_vslarrival_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_vslarrival_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp3_vslarrival_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_vslarrival_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp3_vslarrival_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_vslarrival_actual)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp3_vslarrival_detected) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Detected :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_vslarrival_detected)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 3 Discharge Details")])])]), _vm._v(" "), (_vm.getSingleShipments.tsp3_discharge_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_discharge_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp3_discharge_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_discharge_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp3_discharge_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_discharge_actual)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 3 Loaded Details")])])]), _vm._v(" "), (_vm.getSingleShipments.tsp3_loaded_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_loaded_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp3_loaded_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_loaded_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp3_loaded_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_loaded_actual)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 3 VSL Departure Details")])])]), _vm._v(" "), (_vm.getSingleShipments.tsp3_vsldeparture_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_vsldeparture_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp3_vsldeparture_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_vsldeparture_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp3_vsldeparture_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_vsldeparture_actual)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp3_vsldeparture_detected) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Detected :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_vsldeparture_detected)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 4 VSL Arrival Details")])])]), _vm._v(" "), (_vm.getSingleShipments.tsp4_vslarrival_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_vslarrival_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp4_vslarrival_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_vslarrival_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp4_vslarrival_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_vslarrival_actual)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp4_vslarrival_detected) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Detected :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_vslarrival_detected)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 4 Discharge Details")])])]), _vm._v(" "), (_vm.getSingleShipments.tsp4_discharge_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_discharge_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp4_discharge_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_discharge_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp4_discharge_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_discharge_actual)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 4 Loaded Details")])])]), _vm._v(" "), (_vm.getSingleShipments.tsp4_loaded_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_loaded_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp4_loaded_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_loaded_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp4_loaded_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_loaded_actual)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 4 VSL Departure Details")])])]), _vm._v(" "), (_vm.getSingleShipments.tsp4_vsldeparture_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_vsldeparture_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp4_vsldeparture_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_vsldeparture_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp4_vsldeparture_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_vsldeparture_actual)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp4_vsldeparture_detected) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Detected :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_vsldeparture_detected)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("POD VSL Arrival Details")])])]), _vm._v(" "), (_vm.getSingleShipments.pod_vslarrival_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_vslarrival_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_vslarrival_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_vslarrival_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_vslarrival_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_vslarrival_actual)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_vslarrival_detected) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Detected :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_vslarrival_detected)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("POD Discharge Details")])])]), _vm._v(" "), (_vm.getSingleShipments.pod_discharge_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_discharge_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_discharge_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_discharge_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_discharge_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_discharge_actual)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("POD Departure Details")])])]), _vm._v(" "), (_vm.getSingleShipments.pod_departure_planned_initial) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_departure_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_departure_planned_last) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_departure_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_departure_actual) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_departure_actual)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("LIF Arrival Details")])])]), _vm._v(" "), (_vm.getSingleShipments.lif_arrival_planned_initial) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.lif_arrival_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.lif_arrival_planned_last) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.lif_arrival_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.lif_arrival_actual) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.lif_arrival_actual)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("LIF Departure Details")])])]), _vm._v(" "), (_vm.getSingleShipments.lif_departure_planned_initial) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.lif_departure_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.lif_departure_planned_last) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.lif_departure_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.lif_departure_actual) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.lif_departure_actual)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("DLV Delivery Details")])])]), _vm._v(" "), (_vm.getSingleShipments.dlv_delivery_planned_initial) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.dlv_delivery_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.dlv_delivery_planned_last) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.dlv_delivery_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.dlv_delivery_actual) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.dlv_delivery_actual)))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Empty Return Details")])])]), _vm._v(" "), (_vm.getSingleShipments.empty_return_planned_initial) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Initial :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.empty_return_planned_initial)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.empty_return_planned_last) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Planned Last :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.empty_return_planned_last)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.empty_return_actual) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Actual :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.empty_return_actual)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.empty_return_customer) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Customer :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.empty_return_customer))])])]) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Custom Details")])])]), _vm._v(" "), (_vm.getSingleShipments.customs_release_state) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Custom Release State :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.customs_release_state))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.customs_release_date) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Custom Release Date :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.customs_release_date ? (_vm.getSingleShipments.customs_release_date | _vm.moment) : ""))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.carrier_release_state) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Carrier Release State :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.carrier_release_state))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.carrier_release_date) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Carrier Release Date :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.carrier_release_date ? (_vm.getSingleShipments.carrier_release_date | _vm.moment) : ""))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.availability_date) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Availability :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.availability_date ? (_vm.getSingleShipments.availability_date | _vm.moment) : ""))])])]) : _vm._e()], 1), _vm._v(" "), (_vm.getSingleShipments.leg1_vessel) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Vessel 1 Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("ID : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg1_vessel.id))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("IMO : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg1_vessel.imo))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg1_vessel.name))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.leg2_vessel) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Vessel 2 Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("ID : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg2_vessel.id))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("IMO : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg2_vessel.imo))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg2_vessel.name))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.leg3_vessel) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Vessel 3 Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("ID : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg3_vessel.id))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("IMO : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg3_vessel.imo))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg3_vessel.name))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.leg4_vessel) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Vessel 4 Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("ID : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg4_vessel.id))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("IMO : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg4_vessel.imo))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg4_vessel.name))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.leg5_vessel) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Vessel 5 Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("ID : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg5_vessel.id))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("IMO : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg5_vessel.imo))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg5_vessel.name))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_loc) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("POD Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pod_loc.name))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Locode : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pod_loc.locode))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Timezone : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pod_loc.timezone))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("City : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pod_loc.city))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("State : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pod_loc.state))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Country : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pod_loc.country))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pol_loc) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("POL Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pol_loc.name))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Locode : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pol_loc.locode))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Timezone : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pol_loc.timezone))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("City : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pol_loc.city))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("State : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pol_loc.state))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Country : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pol_loc.country))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.dlv_loc) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("DLV Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.dlv_loc.name))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Locode : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.dlv_loc.locode))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Timezone : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.dlv_loc.timezone))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("City : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.dlv_loc.city))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("State : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.dlv_loc.state))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Country : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.dlv_loc.country))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.origin_loc) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Origin Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.origin_loc.name))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Locode : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.origin_loc.locode))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Timezone : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.origin_loc.timezone))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("City : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.origin_loc.city))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("State : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.origin_loc.state))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Country : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.origin_loc.country))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp1_vslarrival_prediction) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 1 VSL Arrival Prediction Details")])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Created :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp1_vslarrival_prediction.created)))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp1_vslarrival_prediction.predicted)))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted Lower :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp1_vslarrival_prediction.predicted_lower)))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted Upper :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp1_vslarrival_prediction.predicted_upper)))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp2_vslarrival_prediction) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 2 VSL Arrival Prediction Details")])])]), _vm._v(" "), (_vm.getSingleShipments.tsp2_vslarrival_prediction) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Created :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_vslarrival_prediction.created)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp2_vslarrival_prediction) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_vslarrival_prediction.predicted)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp2_vslarrival_prediction) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted Lower :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_vslarrival_prediction.predicted_lower)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp2_vslarrival_prediction) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted Upper :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp2_vslarrival_prediction.predicted_upper)))])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp3_vslarrival_prediction) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 3 VSL Arrival Prediction Details")])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Created :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_vslarrival_prediction.created)))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_vslarrival_prediction.predicted)))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted Lower :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_vslarrival_prediction.predicted_lower)))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted Upper :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp3_vslarrival_prediction.predicted_upper)))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.tsp4_vslarrival_prediction) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Transhipment 4 VSL Arrival Prediction Details")])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Created :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_vslarrival_prediction.created)))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_vslarrival_prediction.predicted)))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted Lower :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_vslarrival_prediction.predicted_lower)))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted Upper :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.tsp4_vslarrival_prediction.predicted_upper)))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_vslarrival_prediction) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("POD VSL Arrival Prediction Details")])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Created :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_vslarrival_prediction.created)))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_vslarrival_prediction.predicted)))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted Lower :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_vslarrival_prediction.predicted_lower)))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted Upper :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_vslarrival_prediction.predicted_upper)))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_timeofarrival_warning) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("POD Discharge Prediction Details")])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Risk Verbose :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pod_timeofarrival_warning.risk_verbose))])])]), _vm._v(" "), (_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("ID :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival.id))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Created :"), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival.created)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Milestone :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival
    .milestone))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted Date :"), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival
    .predicted_date)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival) ? _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Days Diff :"), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival
    .days_diff))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted Date Lower :"), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival
    .predicted_date_lower)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted Date Uppper :"), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival
    .predicted_date_upper)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Expected Date Created :"), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival
    .expected_date_when_created)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Connection Date Created :"), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_timeofarrival_warning.predicted_time_of_arrival
    .connection_date_when_created)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_timeofarrival_warning) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Created :"), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_timeofarrival_warning.created)))])])]) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_timeofarrival_warning) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Modified :"), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_timeofarrival_warning.modified)))])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.pod_discharge_prediction) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("POD Discharge Prediction Details")])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Created :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_discharge_prediction.created)))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_discharge_prediction.predicted)))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted Lower :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_discharge_prediction.predicted_lower)))])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Predicted Upper :\n        "), _c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleShipments.pod_discharge_prediction.predicted_upper)))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.leg1_service) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Leg Service 1 Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("ID : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg1_service.id))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Code : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg1_service.code))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg1_service.name))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Direction :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg1_service.direction))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.leg2_service) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Leg Service 2 Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("ID : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg2_service.id))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Code : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg2_service.code))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg2_service.name))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Direction :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg2_service.direction))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.leg3_service) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Leg Service 3 Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("ID : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg3_service.id))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Code : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg3_service.code))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg3_service.name))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Direction :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg3_service.direction))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.leg4_service) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Leg Service 4 Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("ID : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg4_service.id))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Code : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg4_service.code))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg4_service.name))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Direction :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg4_service.direction))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.leg5_service) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Leg Service 5 Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("ID : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg5_service.id))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Code : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg5_service.code))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg5_service.name))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Direction :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.leg5_service.direction))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.empty_pickup_loc) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mt-1 mb-1",
    staticStyle: {
      "color": "blue"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('u', [_c('b', [_vm._v("Empty Pickup Loc Details")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Name : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.empty_pickup_loc.name))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Locode :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.empty_pickup_loc.locode))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Timezone :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.empty_pickup_loc.timezone))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("City : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.empty_pickup_loc.city))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("State : "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.empty_pickup_loc.state))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('span', [_vm._v("Country :\n        "), _c('strong', [_vm._v(_vm._s(_vm.getSingleShipments.empty_pickup_loc.country))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.getSingleShipments.incidents) ? _c('div', {
    staticClass: "alerts"
  }, _vm._l((_vm.getSingleShipments.incidents), function(incident, index) {
    return _c('div', {
      key: index,
      staticClass: "alert"
    }, [_vm._v("\n      " + _vm._s(incident) + "\n    ")])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('b-modal', {
    ref: "ShipmentLog_modal",
    attrs: {
      "id": "ShipmentLog_modal",
      "title": 'Shipment Log Details Container No : ' + _vm.getSingleShipments.container_number,
      "size": "lg",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getShipmentLogList,
      "responsive": "",
      "fields": _vm.Columns,
      "primary-key": "id_email_section",
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('center', [_c('b-button', {
    staticClass: "mt-2",
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.hideShipmentLog
    }
  }, [_vm._v("Close")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12ca601c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ocean-insights/ContainerDetails.vue
// module id = 2405
// module chunks = 0